import React from 'react';

import { addNotification, Notification } from '@lucidhq/lucidium';

import { useApiFetch } from '~/utils/fetch';

export const useDeleteListItem = (
  url: string,
  method: 'DELETE' | 'PUT' = 'DELETE',
  item: string,
  redirectPath?: string,
  onDelete?: (id: any) => void,
  payload?: any
) => {
  const apiFetch = useApiFetch();

  return async (id: any) => {
    const { error } = await apiFetch<UserItem>({
      url,
      method,
      json: payload ? payload : null
    });
    if (error) {
      addNotification(
        <Notification palette="danger" autoDismissSeconds={3}>
          The {item} could not be deleted.
          <br />
          {error.message}
        </Notification>
      );
    } else {
      typeof onDelete === 'function' && onDelete(id);
      addNotification(
        <Notification palette="success" autoDismissSeconds={3}>
          The {item} was successfully deleted.
        </Notification>
      );
      if (redirectPath) {
        setTimeout(() => {
          window.location.pathname = redirectPath;
        }, 1000);
      }
    }
  };
};
